const utils = require('frontend-controller/lib/utils');

module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'table'
	],

	config: {
		isSortable: true,
		supportLazyloading: false,
		buttonContext: 'offers',
		renderEmptyBeforReady: false,
		showHead: true,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: true,
		inline: true,
		preventSortOfField: {
			// customerName: true,
			// shippingOrderCreatedByEmployeeID: true,
			// shippingOrderIsSigned: true,
			// sentToEmail: true,
		},
		// maxNrOfExportElements: 500000,
		// privilegeBase: 'nl_mailings',
		rowActionsProperties: {
			colWidth: '40px',
		// 	colSpan: 1,
		// 	rowSpan: 2
		},
		// customColActionsFile: 'templates/newsletter/mailings/table/customColActions',

		// // rowActions: {
		// // 	delete: true,
		// // 	edit: true,
		// // 	customs: [{
		// // 		buttonType: 'showDuplicate',
		// // 		buttonContext: 'mailing'
		// // 	}]
		// // },
		rowActions: {
			customs: [
				{
					buttonType: 'download',
					// mode: 'offer',
					// privilegeCode: 'bo_offers:read',
					icon: 'fi fi-download',
					inline: true,
					neutral: true,
				},
			]
		},

		// autoInsertWhenEmpty: false, // if one opens up this table and there are no data to be shown, then this is an employee trying to create a shippingOrder.
		heartbeatRefreshOn: {
			'reconnect': true,
			// 'resourceChanged.all': true,
			// 'resourceChanged.bo_projects': true,
			// // 'resourceChanged.bo_customers': true,
			// // 'resourceChanged.bo_employees': true,
			// 'resourceChanged.bo_projectTerms': true,
			// 'resourceChanged.bo_projectTermJobs': true,
			// 'resourceChanged.bo_projectTermJobStatus': true,
			// // 'resourceChanged.bo_customerContacts': true,

			// 'resourceChanged.bo_shippingOrders': true,
			// 'resourceChanged.bo_invoices': true,
			'resourceChanged.bo_offers': true,
			'resourceChanged.bo_customers': true,
		},
	},

	model: {
		// projectID: null, // actual projectID
		// projectTermID: null, // actual projectTermID
	},

	methods: {

		async download(rowID, rowData, buttonMode){
			if (((rowData || {}).attributes || {}).url) {
				window.open(`${rowData.attributes.url}.pdf`)
			}
		},

		async showEdit(rowID, rowData, buttonMode){
			if (((rowData || {}).attributes || {}).url) {
				window.open(rowData.attributes.url)
			}
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers = this.config.heartbeatRefreshOn || {}
			const key = message.heartbeatKey
			const projectID = ((this.model.parentEntityForTable || {}).baseFilters || {}).projectID

			if(refreshers[key] && (
				(key === 'resourceChanged.bo_customers') ||
				(
					(
						key !== 'resourceChanged.bo_offers'
					) || (!projectID || message.data.projectID == projectID || (message.data.projectIDs || {})[projectID])
				)
			)){
				this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
			}
		},
	},
}
